import { useEffect, useState } from "react";
import { useScope } from "../../../container/SelectProjectCompanyContainer";
import { useDispatch, useSelector } from "react-redux";

export const useJourney = () => {
  const dispatch = useDispatch();
  const journey = useSelector(state => state.app?.journey);
  const { scope } = useScope();
  const [reload, setReload] = useState(true);

  const loadJourneyData = async () => {
    const response = await Send.get(`/dw/journey/${scope?.id}`);
    dispatch(setData({ journey: response || [] }));
  };

  useEffect(() => {
    if(reload) {
      loadJourneyData();
      setReload(false);
    }
  }, [reload]);


  return { journey, reload, setReload };
}